import { message } from "antd"
import docCookies from "../util/docCookies"
import Util from "./util"
import { logout as signOut, getToken, jdLogout } from "../api/common"
import {
  AUTH_URL,
  APPID,
  COOKIE_DOMAIN,
  APPID_JD,
  AUTH_URL_JD
} from "../constants/conf"

const session_url_key = "_LAST_PATH"
const keys = ["potoken", "ktoken", "userRole", "user_name", "user_type"]
const IS_IN_FRAME = window.self !== window.top

export type User = {
  potoken?: string
  ktoken?: string
  userRole?: string
  user_name?: string
  user_type?: string
  oauth_uname?: string
  expires?: number | string | Date
  [propName: string]: any
}

interface AuthType {
  isAuthenticated: boolean
  user: User
  signout: <T extends Function>(cb: T) => void
  auth: (user: User) => void
  getRedirectUri: () => string
  goToAuth: () => void
}

const Auth: AuthType = {
  isAuthenticated: false,
  user: {} as User,
  signout(cb) {
    this.isAuthenticated = false
    this.user = {} as User
    setTimeout(cb, 100)
  },
  auth(user) {
    if (user) {
      this.isAuthenticated = true
      this.user = user
    }
  },
  getRedirectUri() {
    return window.location.origin + "/#/auth"
  },
  goToAuth() {
    let url, id, state, redirectUrl

    if (COOKIE_DOMAIN.includes("jdcloud-elite")) {
      url = AUTH_URL_JD
      id = APPID_JD
      state = "jdcloud"
      redirectUrl = window.location.origin + "/?source=jdCloud"
    } else {
      url = AUTH_URL
      id = APPID
      state = "wayz"
      redirectUrl = this.getRedirectUri()
    }
    window.location.href = `${url}?response_type=code&client_id=${id}&redirect_uri=${encodeURIComponent(
      redirectUrl
    )}&state=${state}`
  }
}

interface Env {
  isLogin: () => boolean
  getUser: () => User
  logout: () => void
  requestUserInfo: (cb: () => void) => void
  authCode: (
    code: string,
    cb: (user: User, lastUrl: string | null) => void
  ) => void
  isInFrame: boolean
  [propsName: string]: any
}

const Env: Env = {
  isInFrame: IS_IN_FRAME,
  isLogin: () => Auth.isAuthenticated,
  getUser: () => Auth.user,
  logout: async () => {
    if (IS_IN_FRAME) {
      let p = window.parent
      p.postMessage({ action: "logout" }, "*")
      return
    }

    Auth.isAuthenticated = false
    // 存储最后的连接
    sessionStorage.setItem(
      session_url_key,
      window.location.hash.replace("#", "")
    )

    docCookies.removeItem("potoken", "/", COOKIE_DOMAIN)

    if (COOKIE_DOMAIN.includes("jdcloud-elite")) {
      try {
        // jd token invalid
        await signOut("jdCloud")
        await jdLogout()
      } catch (error) {}
    }

    Auth.goToAuth()
  },

  requestUserInfo: cb => {
    const query: { [propsName: string]: any } = Util.parseQuery(
      window.location.search
    )

    // jd account login
    if (query.source === "jdCloud" && query.code) {
      window.location.href = `${window.location.origin}/#/auth?code=${query.code}`
      return
    }

    if (Auth.isAuthenticated) {
      cb()
      return
    }

    if (window.location.hash.includes("#/auth")) {
      cb()
      return
    }

    const user = docCookies.parsedCookies()

    if (user && user["potoken"]) {
      Auth.auth(user)
      cb()
      return
    }

    Auth.goToAuth()
  },

  authCode: async (code, cb) => {
    if (!code) {
      Auth.goToAuth()
    } else {
      let platform
      if (COOKIE_DOMAIN.includes("jdcloud-elite")) {
        platform = "jdCloud"
      } else {
        platform = "wayz"
      }

      getToken(code, platform, encodeURIComponent(Auth.getRedirectUri()))
        .then(res => {
          const user = res.data || {}
          if (res.code === 0 && user.potoken) {
            user.expires = user.expires_in
            keys.forEach(sKey => {
              if (!!user[sKey]) {
                docCookies.setItem(
                  sKey,
                  user[sKey],
                  "/",
                  user.expires,
                  COOKIE_DOMAIN
                )
              }
            })

            Auth.auth(user)
            cb && cb(user, sessionStorage.getItem(session_url_key))
          } else if (res.code === 401) {
            message.error(res.msg)
            // Auth.goToAuth()
          }
        })
        .catch(err => {
          console.log(`Dragon: err`, err)
        })
    }
  }
}

export default Env
